/**
 * Similar to the NodeJS EventEmitter.
 */
export class EventEmitter {
    constructor() {
        this.listeners = {};
    }
    /**
     * Registers a handler for an event.
     */
    on(eventName, handler) {
        const eventHandlers = this.listeners[eventName] == null ? [] : this.listeners[eventName];
        eventHandlers.push(handler);
        this.listeners[eventName] = eventHandlers;
        return this;
    }
    /**
     * Removes/deregisters an existing handler for an event.
     */
    off(eventName, handler) {
        var _a;
        if (handler == null)
            return this;
        const eventHandlers = (_a = this.listeners[eventName]) !== null && _a !== void 0 ? _a : [];
        const indexOfHandler = eventHandlers.indexOf(handler);
        if (indexOfHandler === -1) {
            throw new Error('Handler to remove was not found.');
        }
        eventHandlers.splice(indexOfHandler, 1);
        return this;
    }
    /**
     * Raises an event, calling all listeners registered to it with the provided arguments.
     */
    emit(eventName, ...args) {
        const listeners = this.listeners[eventName];
        if (listeners == null) {
            return this;
        }
        listeners.forEach((handler) => handler(...args));
        return this;
    }
    /**
     * A version of this event emitter with the `emit` method hidden.
     */
    asProtected() {
        return {
            on: this.on.bind(this),
            off: this.off.bind(this),
        };
    }
    ;
    /**
     * Creates a wrapper/delegate method for the one of the public methods of this emitter that returns
     * `self` instead of the `EventEmitter` instance. Useful for exposing the `on`
     * method without exposing the entire emitter through the original method's self-return value.
     * @param methodName The method to create a delegate for.
     * @param self The value that the delegate will return.
     */
    makeDelegate(methodName, self) {
        return (...args) => {
            // The cast here is unavoidable because methodName could be any of the methods, which don't
            // have compatible method signatures (`emit` for example is unique).
            // As long as an overload is provided, things will typecheck correctly on the client's end,
            // but the implementation body is unaware of overloads and thus we need this cast
            // and future make delegate targets will need their own overloads--otherwise
            // makeDelegate might be uncallable (parameters will be of type never) due to TS attempting
            // to union the parameter types of all methods, which will be `never` due to lack of overlap.
            this[methodName](...args);
            return self;
        };
    }
    /**
     * Gets the number of listeners listening to a specific event.
     * @param eventName The event.
     */
    listenerCount(eventName) {
        return this.listeners[eventName] == null ? 0 : this.listeners[eventName].length;
    }
}
//# sourceMappingURL=event-emitter.js.map